import React from 'react';
import { Link } from 'react-router-dom';

const ProjectCard = ({ project }) => {
  const img = project.images && project.images.length ? project.images[0].url : null;

  const techBadges = (project.technologies || []).map((t, i) => (
    <span key={i} className="px-3 py-1 bg-neutral-100 text-gray-700 text-xs rounded-full font-medium">
      {t}
    </span>
  ));

  return (
    <div className="interactive-card">
      {img ? (
        <div className="relative overflow-hidden">
          <img loading="lazy" src={require(`../images/${img}`)} alt={project.title} className="w-full h-56 object-cover group-hover:scale-105 transition-transform duration-300" />
        </div>
      ) : (
        <div className="w-full h-56 bg-neutral-100 flex items-center justify-center">No image</div>
      )}

      <div className="p-5">
        <h3 className="text-lg font-semibold brand-text mb-2">{project.title}</h3>
        <p className="text-sm muted-text mb-3 line-clamp-3">{project.description}</p>
        <div className="flex flex-wrap gap-2 mb-4">{techBadges}</div>
        <div className="flex items-center justify-between">
          <span className="text-xs muted-text">{project.date || project.year || ''}</span>
          <div className="flex gap-2">
            <Link to={`/projects/${project.slug}`} className="underline-animate text-sm font-medium">
              Case Study
            </Link>
            {project.links && project.links[0] ? (
              <a href={project.links[0].url} target="_blank" rel="noopener noreferrer" className="px-3 py-1 rounded-md accent-btn text-sm">
                Live
              </a>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectCard;
